var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9437 0 0 17.9437 0 40C0 62.0563 17.9437 80 40 80C62.0563 80 80 62.0563 80 40C80 17.9437 62.0563 0 40 0Z",
    fill: "url(#paint0_linear_1075_610)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70C23.4587 70 10 56.5412 10 40C10 23.4587 23.4587 10 40 10C56.5412 10 70 23.4587 70 40C70 56.5412 56.5412 70 40 70Z",
    fill: "url(#paint1_linear_1075_610)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5184 53.75C19.6547 53.75 18.8135 53.3013 18.351 52.5C17.661 51.3038 18.0697 49.775 19.2659 49.085L21.4309 47.835C22.6284 47.1438 24.1559 47.555 24.8459 48.75C25.5359 49.9463 25.1272 51.475 23.9309 52.165L21.766 53.415C21.3722 53.6425 20.9422 53.75 20.5184 53.75ZM58.5735 32.165L60.7372 30.915C61.9322 30.225 62.3422 28.695 61.651 27.5C60.9597 26.305 59.4322 25.895 58.236 26.5863L56.0722 27.8363C54.8772 28.5263 54.4672 30.0563 55.1585 31.2513C55.6222 32.0525 56.461 32.5013 57.326 32.5013C57.7497 32.5 58.1785 32.3925 58.5735 32.165ZM30.9172 60.7363L32.1684 58.5713C32.8584 57.375 32.4497 55.8463 31.2547 55.1563C30.0572 54.4663 28.5297 54.875 27.8397 56.07L26.5885 58.235C25.8985 59.4313 26.3072 60.96 27.5022 61.65C27.8959 61.8775 28.3259 61.9863 28.7509 61.9863C29.6135 61.9863 30.4534 61.5375 30.9172 60.7363ZM52.1685 23.9288L53.4172 21.765C54.1072 20.5688 53.6972 19.04 52.5009 18.35C51.3035 17.6575 49.7747 18.07 49.086 19.2663L47.8372 21.43C47.1472 22.6263 47.5572 24.155 48.7534 24.845C49.1472 25.0725 49.5772 25.18 50.0009 25.18C50.8647 25.18 51.706 24.7313 52.1685 23.9288ZM52.5009 61.65C53.6972 60.96 54.1072 59.4313 53.4172 58.235L52.1672 56.0688C51.476 54.8725 49.9485 54.4613 48.7522 55.1525C47.556 55.8425 47.146 57.3713 47.836 58.5675L49.086 60.7338C49.5497 61.5363 50.3897 61.985 51.2534 61.985C51.6784 61.985 52.1085 61.8763 52.5009 61.65ZM31.2522 24.8425C32.4484 24.1513 32.8572 22.6225 32.1659 21.4275L30.9159 19.2638C30.226 18.0675 28.6959 17.6613 27.5009 18.35C26.3047 19.0413 25.8959 20.57 26.5872 21.765L27.8372 23.9288C28.3009 24.7313 29.141 25.1788 30.0047 25.1788C30.4284 25.1775 30.8597 25.0688 31.2522 24.8425ZM61.6522 52.4988C62.3422 51.3025 61.9335 49.7738 60.7384 49.0838L58.5735 47.8325C57.3772 47.14 55.8484 47.5513 55.1585 48.7463C54.4684 49.9425 54.8772 51.4713 56.0722 52.1613L58.2372 53.4125C58.631 53.64 59.061 53.7488 59.486 53.7488C60.3485 53.7488 61.1884 53.3 61.6522 52.4988ZM24.8472 31.2463C25.5372 30.05 25.1272 28.5213 23.9309 27.8325L21.766 26.5838C20.5685 25.8938 19.0409 26.3038 18.3522 27.5C17.6622 28.6963 18.0722 30.225 19.2684 30.9138L21.4334 32.1625C21.8272 32.39 22.2559 32.4975 22.6797 32.4975C23.5434 32.4988 24.3847 32.0488 24.8472 31.2463Z",
    fill: "url(#paint2_linear_1075_610)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 42.5C16.8375 42.5 16.2 42.2375 15.7375 41.7625C15.2625 41.3 15 40.6625 15 40C15 39.3375 15.2625 38.7 15.7375 38.2375C16.6625 37.3 18.3375 37.3 19.2625 38.2375C19.7375 38.7 20 39.35 20 40C20 40.65 19.7375 41.3 19.2625 41.7625C18.8 42.2375 18.1625 42.5 17.5 42.5ZM64.275 41.7625C64.7375 41.3 65 40.6625 65 40C65 39.3375 64.7375 38.7 64.2625 38.225C63.3375 37.3 61.6625 37.3 60.725 38.2375C60.2625 38.7 60 39.35 60 40C60 40.65 60.2625 41.3 60.7375 41.775C61.2 42.2375 61.8375 42.5 62.5 42.5C63.15 42.5 63.8 42.2375 64.275 41.7625ZM41.775 19.2625C42.2375 18.8 42.5 18.1625 42.5 17.5C42.5 16.8375 42.2375 16.2 41.7625 15.725C40.8375 14.8 39.1625 14.8 38.225 15.7375C37.7625 16.2 37.5 16.85 37.5 17.5C37.5 18.15 37.7625 18.8 38.2375 19.275C38.7 19.7375 39.3375 20 40 20C40.65 20 41.3 19.7375 41.775 19.2625ZM41.775 64.2625C42.2375 63.8 42.5 63.1625 42.5 62.5C42.5 61.8375 42.2375 61.2 41.7625 60.725C40.8375 59.8 39.1625 59.8 38.225 60.7375C37.7625 61.2 37.5 61.85 37.5 62.5C37.5 63.15 37.7625 63.8 38.2375 64.275C38.7 64.7375 39.3375 65 40 65C40.65 65 41.3 64.7375 41.775 64.2625ZM42.5 40V27.5C42.5 26.12 41.38 25 40 25C38.62 25 37.5 26.12 37.5 27.5V37.5H32.5C31.12 37.5 30 38.62 30 40C30 41.38 31.12 42.5 32.5 42.5H40C41.38 42.5 42.5 41.38 42.5 40Z",
    fill: "url(#paint3_linear_1075_610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1075_610",
    x1: 11.73,
    y1: 68.2712,
    x2: 68.2713,
    y2: 11.7287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1075_610",
    x1: 18.7975,
    y1: 61.2038,
    x2: 61.2038,
    y2: 18.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1075_610",
    x1: 22.8659,
    y1: 57.1363,
    x2: 57.1385,
    y2: 22.8638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1075_610",
    x1: 26.9813,
    y1: 53.0188,
    x2: 53.0187,
    y2: 26.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock1);
export default __webpack_public_path__ + "static/media/clock-1.26fc4dcdea878d2d0d1ee2d92b59fefe.svg";
export { ForwardRef as ReactComponent };